export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 80,
    slots: { default: 'opt', },
  },
  {
    title: that.$l('INDEX.table_label_product_information') || '产品信息',
    headerAlign: 'left',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    slots: { default: 'goodsTitle' }
  },
  {
    title: that.$l('table_label_productName') || '产品名称',
    field: 'productName',
    headerAlign: 'left',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_salesPrice') || '售卖价格',
    field: 'v_salesPrice',
    width: 120,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_snapshotDate') || '库存记录日期',
    field: 'snapshotDate',
    headerAlign: 'left',
    align: 'left',
    width: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_storeName') || '店铺名称',
    field: 'storeName',
    headerAlign: 'left',
    align: 'left',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_originalFileName') || '原始文件名',
    field: 'originalFileName',
    headerAlign: 'left',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    slots: { default: 'originalFile' }
  },
]
